import { clsx } from 'clsx';
import type { XAxisTickContentProps } from 'recharts';

import * as styles from '../styles.css';

export const customizedGroupTick = (props: XAxisTickContentProps) => {
  const { index, x, y, payload } = props;
  const xNum = Number(x);
  const yNum = Number(y);

  return (
    <g>
      <g>
        {index !== 0 && (
          <circle
            fill="#7683A0"
            cx={xNum}
            cy={yNum + 4}
            r={3}
            stroke="#7683A0"
            className={clsx(styles['pin'], styles['custom-pin'])}
          />
        )}
        <text
          orientation="bottom"
          width="490"
          height="30"
            stroke="none"
            x={xNum}
            y={yNum + 5}
            textAnchor="middle"
            fill="#666"
        >
          <tspan x={xNum} dy="20px">
            {payload.value}
          </tspan>
        </text>
      </g>
    </g>
  );
};
